<template>
   <div>
    <v-container class="payment-method-container">    
        <v-row dense  v-show="achMethods.length">
          <v-col :cols="$vuetify.breakpoint.xs ? 12 : 6" >
            <div  class="card-methods-content">
            <v-radio-group dense v-model="method" :mandatory="false"   @change="handleMethodChange">
              <v-radio value="existing">
                <template v-slot:label>
                  <v-select
                    :disabled="method !== 'existing'"
                    hide-details
                    :value="payment.payment_method_id"
                    :items="achMethods"
                    item-value="id"
                    item-text="card_end"
                    :error-messages="errors.collect('existing_payment_method_id')"
                    placeholder="Account On File"
                    dense
                    @change="handleUpdate('payment','payment_method_id',$event)"
                    v-validate="method === 'existing'? 'required' : ''"
                    :class="{'custom-field-error' : errors.first('existing_payment_method_id')}"
                    name="existing_payment_method_id"
                    id="existing_payment_method_id"
                    data-vv-name="existing_payment_method_id"
                    data-vv-as="Account On File"
                  >
                    <template v-slot:selection="data" >
                      {{data.item.card_type | capitalize}}  ****{{data.item.card_end.slice(-4)}}
                    </template>

                    <template v-slot:item="data" >

                      <v-list-item-content>
                        <v-list-item-title>
                          <strong>{{data.item.name_on_card}} </strong>
                        </v-list-item-title>
                        <v-list-item-subtitle>{{data.item.card_type | capitalize}} ****{{data.item.card_end.slice(-4)}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </template>
              </v-radio>

              <v-radio value="new">
                <template v-slot:label>
                  <v-icon class="mr-3">mdi-bank</v-icon> New Bank Account
                </template>
              </v-radio>
            </v-radio-group>
          </div>
          </v-col>
        </v-row>
                                  
      <div v-show="method === 'new'">
        <v-row dense no-gutters class=" d-flex justify-space-between">
          <v-col :cols="$vuetify.breakpoint.xs ? 5 : 6" >
            <v-text-field
              :class="{'custom-field-error' : errors.first('first')}"
              hide-details
              :value="payment_method.first"
              v-validate="'required|max:45'"
              data-vv-name="first"
              data-vv-as="First Name"
              :error-messages="errors.collect('first')"
              label="First Name*"
              id="account-first-name"
              name="account-first-name"
              autocomplete="cc-account-first-name"
              @input="handleInputUpdate('payment_method','first',$event)"
              >
            </v-text-field>
          </v-col>
          <v-col class="pa-0" :cols="$vuetify.breakpoint.xs ? 6 : 12">
            <v-col :cols="$vuetify.breakpoint.xs ? 12 : 6" class="pa-0">
            <v-text-field
              :class="{'custom-field-error' : errors.first('last')}"
              hide-details
              :value="payment_method.last"
              v-validate="'required|max:45'"
              data-vv-name="last"
              data-vv-as="Last Name"
              :error-messages="errors.collect('last')"
              label="Last Name*"
              id="account-last-name"
              name="account-last-name"
              autocomplete="cc-account-last-name"
              @input="handleInputUpdate('payment_method','last',$event)"
              >
            </v-text-field>
          </v-col>
          </v-col>
          
        </v-row>

        <v-row dense>
          <v-col :cols="$vuetify.breakpoint.xs ? 12 : 6">
            <v-select
              :class="{'custom-field-error' : errors.first('account_type')}"
              hide-details
              :value="payment_method.account_type"
              :items="account_types"
              v-validate="'required'"
              data-vv-name="account_type"
              data-vv-as="Account Type"
              :error-messages="errors.collect('account_type')"
              label="Account Type*"
              @change="handleUpdate('payment_method','account_type',$event)"
              >
            </v-select>
          </v-col>
        </v-row>

        <v-row dense class="mt-3 mb-1">
          <v-col cols="12" class="custom-label" :class="{'error-label'  : errors.has('routing_number')}">Routing Number:</v-col>
          <v-col :cols="$vuetify.breakpoint.xs ? 12 : 6" class="pa-0 ">
            <hb-text-field
              box
              tile
              hide-details
              :value="payment_method.routing_number"
              data-vv-name="routing_number"
              v-validate="'required|numeric|max:45'"
              data-vv-as="Routing Number"
              :error="errors.collect('routing_number').length > 0"
              label="Routing Number*"
              id="account-routing-number"
              name="account-routing-number"
              autocomplete="cc-account-routing-number"
              @input="handleInputUpdate('payment_method','routing_number',$event)"
              @blur="$validator.validate('routing_number')"
              >
            </hb-text-field>
          </v-col>
        </v-row>

        <v-row dense class="mt-2 mb-1">
          <v-col cols="12" class="custom-label" :class="{'error-label'  : errors.has('account_number')}">Account Number:</v-col>
          <v-col :cols="$vuetify.breakpoint.xs ? 12 : 6" class="pa-0 ">
            <hb-text-field
              box
              tile
              hide-details
              :value="payment_method.account_number"
              data-vv-name="account_number"
              v-validate="'required|numeric|max:45'"
              data-vv-as="Account Number"
              :error="errors.collect('account_number').length > 0"
              label="Account Number*"
              id="account-number"
              name="account-number"
              autocomplete="cc-account-number"
              @input="handleInputUpdate('payment_method','account_number',$event)"
              @blur="$validator.validate('account_number')"
              >
            </hb-text-field>
          </v-col>
        </v-row>

        <v-row class="mt-2 mb-1" v-if="!dense_header && paymentConfig.SHOW_SAVE_PAYMENT">
          <v-col >
            <v-checkbox class="pt-0" style="margin-top: 2px;" :disabled="auto_charge" hide-details :input-value="payment_method.save_to_account" @change="updateSaveToAccount($event)" label="Save Payment Method"></v-checkbox>
          </v-col>
        </v-row>

        <v-row dense v-if="!dense_header" no-gutters class="mb-6">
          <v-col :cols="$vuetify.breakpoint.xs ? 12 : 6">
            <v-textarea
              :class="{'custom-field-error' : errors.first('notes')}"
              hide-details
              :value="payment.notes"
              data-vv-name="notes"
              data-vv-as="Notes"
              :error-messages="errors.collect('notes')"
              label="Notes"
              id="account-notes"
              name="account-notes"
              autocomplete="cc-account-notes"
              @input="handleInputUpdate('payment','notes',$event)"
              class="pt-2 mt-1"
              backgroundColor=""
              rows="1"
              auto-grow
              >
            </v-textarea>
          </v-col>
        </v-row>

      </div>

    </v-container>
  </div>
</template>

<script type="text/babel">
    import HbDatePicker from '../../assets/HummingbirdDatepicker';
    import PaymentMethodBase from './PaymentMethodBase.vue';
    import { mapGetters, mapMutations } from "vuex";
    import { EventBus } from '../../../EventBus';

    export default {
        data() {
            return {
                method: null,
                account_types:['Checking', 'Savings']
            }
        },
        components:{
            HbDatePicker
        },
        computed:{
            ...mapGetters({
              paymentConfig: 'paymentsStore/getPaymentSourceConfig',
              getErrors: 'paymentsStore/getErrors',
              payment_methods: 'paymentsStore/getContactPaymentMethods',
              payment_method: 'paymentsStore/getPaymentMethod',
              payment: 'paymentsStore/getPayment',
            }),
            achMethods(){
                return this.payment_methods.filter(pm => pm.type === 'ach');
            }
        },
        destroyed() {
        },
        mounted(){
            if(this.achMethods.length){
                this.method = 'existing';
            } else {
                this.method = 'new';
            }
        },
        props: ['auto_charge','dense_header'],
        methods:{
            ...mapMutations({
              setCheckErrors: 'paymentsStore/setCheckErrors',
              setPayment: 'paymentsStore/setPayment',
              setPaymentMethod: 'paymentsStore/setPaymentMethod',
              setPaymentObject: 'paymentsStore/setPaymentObject',
              setPaymentMethodObject: 'paymentsStore/setPaymentMethodObject',
            }),

            handleUpdate(obj, property_name, property_value){
              if(obj === 'payment'){
                this.setPayment({property: property_name, propertyValue: property_value});
              }
              if(obj === 'payment_method'){
                this.setPaymentMethod({property: property_name, propertyValue: property_value});
              }
            },

            handleInputUpdate : _.debounce(async function(obj, property_name, property_value) {
              this.handleUpdate(obj, property_name, property_value);
            }, 200),

            updateSaveToAccount(val){
              this.setPaymentMethod({property: 'save_to_account', propertyValue: !!val}); 
            },
            handleMethodChange(){
              this.$validator.reset();
              if(this.method!='existing'){
                this.payment.payment_method_id = null;
              }
            },
            validateFields(){
              if(this.method === 'existing'){
                return this.$validator.validate('existing_payment_method_id')
              }
              if(this.method === 'new'){
                return this.$validator.validateAll();
              }
            }
        },
        watch:{
          auto_charge: {
            handler() {
                this.setPaymentMethod({
                    property: 'save_to_account',
                    propertyValue: this.auto_charge
                });
            },
            immediate: true
        }
        }


    }
</script>
<style scoped>
  .label-heading-1 {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #101318;
  }
  .card-methods-content{
    padding: 12px;
    border: 1px solid #C4CDD5;
    border-radius: 6px;
    margin-top: 8px;
  }
  .hb-text-field-width-370{
    max-width: 100% !important;
  }
  .custom-label{
    font-size: 12px;
    font-weight: 400;
    color: #637381;
  }
 .custom-field-error ::v-deep .v-input__control .v-input__slot::before {
  border-style: none !important;
}
.error-label{
   color: #ff5252;
}
</style>

